import React from 'react';
import { ParticipantsType } from '../../const';
type ParticipantsProps = {
  participants: ParticipantsType[];
};
export const ListOfParticipants = (props: ParticipantsProps) => {
  const { participants } = props;
  return (
    <div className="tw-flex tw-flex-col tw-gap-y-1 tw-h-auto tw-w-max">
      {participants.length > 0 &&
        participants.map((participant) => (
          <div
            className="tw-bg-white tw-bg-opacity-40 md:tw-bg-opacity-25 tw-rounded-10 tw-px-2 tw-py-1 tw-w-24 md:tw-w-28 "
            key={participant.number}
          >
            <span className="tw-text-xs tw-w-full tw-text-secondary-70 md:tw-text-secondary-51 tw-line-clamp-1">
              {participant.fullName}
            </span>
            <span className="tw-text-white tw-mt-0 md:tw-mt-1 tw-text-xs md:tw-text-13">{participant.number}</span>
          </div>
        ))}
    </div>
  );
};
